var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.70751 2.07993C7.70751 2.07993 3.15527 1.58034 2.14366 3.07915C0.929725 10.6732 7.70752 16.9017 11.2482 19.0667C14.283 20.7321 20.3527 23.2635 21.162 21.265C22.1736 18.767 22.1736 17.0683 21.6678 16.0691C21.2631 15.2697 17.8236 13.9041 16.3062 13.571L14.283 15.7693C11.8551 15.3696 8.71913 11.7391 7.70751 10.0737L9.73074 8.07526C9.73074 5.27744 8.38192 2.91262 7.70751 2.07993Z",
    fill: "#222222"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7915 9.57865C17.5465 8.73419 17.0841 7.96927 16.4508 7.36075C15.8175 6.75224 15.0355 6.32158 14.1836 6.11206M21.999 7.7981C21.65 6.26909 20.8324 4.88791 19.661 3.84814C18.4896 2.80837 17.0231 2.16213 15.4669 2",
    stroke: "#222222",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.777ced1d707164a4caa678f3d59e92bb.svg";
export { ForwardRef as ReactComponent };